import { ActGlo, ActPro } from '../App_Data/ActionTypes';

const initialState = {
    Pro: ActGlo.EN_COURS_DE_CHARGEMENT,
    Historique: ActGlo.EN_COURS_DE_CHARGEMENT,
    Civilites: ActGlo.EN_COURS_DE_CHARGEMENT,
    Pays: ActGlo.EN_COURS_DE_CHARGEMENT,
};

function ProStore(state = initialState, action) {
    switch (action.type) {
    case ActGlo.RESET_STORE:
    case ActGlo.CHANGE_COP_SEL:
        return initialState;
    case ActPro.PRO_AJOUT:
        return {
            ...state,
            Pro: action.data,
        };
    case ActPro.PRO_HISTORIQUE_AJOUT:
        return {
            ...state,
            Historique: action.data,
        };
    case ActPro.PRO_CIVILITES_AJOUT:
        return {
            ...state,
            Civilites: action.data,
        };
    case ActPro.PRO_PAYS_AJOUT:
        return {
            ...state,
            Pays: action.data,
        };
    default:
        return state;
    }
}

export default ProStore;



// WEBPACK FOOTER //
// ./src/Reducers/ProStore.js